// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SidebarComments-cls1__badc89dc84908abed930{/*!*/}.SidebarComments-cls2__c3b1b5cc3036b07bf1a5{padding-bottom:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SidebarComments-cls1__badc89dc84908abed930",
	"cls2": "SidebarComments-cls2__c3b1b5cc3036b07bf1a5 SidebarComments-cls1__badc89dc84908abed930"
};
export default ___CSS_LOADER_EXPORT___;
